export default __webpack_public_path__ + "static/media/ab_dimond.ea297f56.svg";